import { render, staticRenderFns } from "./billing-table.vue?vue&type=template&id=2f7881cb&scoped=true&"
import script from "./billing-table.vue?vue&type=script&lang=js&"
export * from "./billing-table.vue?vue&type=script&lang=js&"
import style0 from "./billing-table.vue?vue&type=style&index=0&id=2f7881cb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7881cb",
  null
  
)

export default component.exports